import { Space } from 'antd';

import { RequestInfo } from '@component/request-info/request-info';
import { ResponseInfo } from '@component/response-info/response-info';
import { RequestSubInterface } from '@interface/logs/logs.interface';

export const requestSubLogsInfo = (request: RequestSubInterface) => (
  <>
    <Space direction='vertical' size={16}>
      <RequestInfo request={request.request} />
      <ResponseInfo response={request.response} />
    </Space>
  </>
);
